var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TopicSectionBlockVar = void 0;

var react_1 = __importDefault(require("react"));

var get_topic_options_1 = require("../../lib/get-topic-options");

var topic_1 = require("../topic/topic");

var core_1 = require("@wheelroom/core");

var topic_section_wrapper_1 = require("./topic-section-wrapper");

exports.TopicSectionBlockVar = function (props) {
  var sectionWheel = core_1.getSectionWheel({
    themeId: props.theme || props.activeThemeId,
    wheelId: 'topicSection',
    sectionWheels: props.sectionWheels,
    variation: 'block'
  });

  if (!sectionWheel || !props.topics) {
    return null;
  }

  var data = sectionWheel.data,
      wheel = sectionWheel.wheel;
  return react_1.default.createElement(topic_section_wrapper_1.TopicSectionWrapper, {
    containerStyle: "container",
    wheel: wheel
  }, props.topics.map(function (topic, index) {
    return react_1.default.createElement(topic_1.Topic, {
      data: data,
      key: index,
      topic: topic,
      topicOptions: get_topic_options_1.getTopicOptions({
        optionStrings: props.topicOptions,
        locale: props.locale
      }),
      wheel: Object.assign(Object.assign({}, wheel), {
        style: wheel.style.topic
      })
    });
  }));
};